




































	// @ts-ignore
    import _ from './AccountChange.ts'; export default _;
